export const USER_SESSION = "USER_SESSION";
export const USER_SESSION_IS_LOADING = "USER_SESSION_IS_LOADING";
export const USER_SESSION_LOADED = "USER_SESSION_LOADED";
export const USER_ACTIVATION_STATE = "USER_ACTIVATION_STATE";
export const USER_CONSULT_INFO = "USER_CONSULT_INFO";
export const USER_CONSULT_INFO_IS_LOADING = "USER_CONSULT_INFO_IS_LOADING";
